import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { IAppConfig, LogicConfig, TextConfig } from './app-config.model';

@Injectable({
  providedIn: 'root'
})
export class AppConfig {
  private _settings: IAppConfig = {} as IAppConfig; // config.dev.***.json
  private _text: TextConfig = {} as TextConfig; // text.json
  private _logic: LogicConfig = {} as LogicConfig; // MI/PCM/config.json

  load(): Promise<boolean> {
    return new Promise<boolean>(
      (r, v) => this.loadConfigFromFile(LoadConfigType.SETTINGS, r, v)
    ).then(() => new Promise<boolean>(
      (r, v) => this.loadConfigFromFile(LoadConfigType.TEXT, r, v)
    )).then(() => new Promise<boolean>(
      (r, v) => this.loadConfigFromFile(LoadConfigType.LOGIC, r, v)
    ));
  }

  public isPCM(): boolean {
    return this.settings.instituteName === 'PCM';
  }

  public isMI(): boolean {
    return this.settings.instituteName === 'MI';
  }

  public get settings(): IAppConfig {
    return this._settings;
  }

  public get text(): TextConfig {
    return this._text;
  }

  public get logic(): LogicConfig {
    return this._logic;
  }

  public isSottoFascicolo(level: number): boolean {
    return this._logic.hierarchy.labels[level].toLocaleLowerCase() === 'sottofascicolo';
  }

  public isSottoServizioInterno(level: number): boolean {
    return this._logic.hierarchy.labels[level].toLocaleLowerCase() === 'servizio interno';
  }

  private loadConfigFromFile(load: LoadConfigType, resolve: (value: boolean | PromiseLike<boolean>) => void, reject: (reason?: string) => void) {
    const xhr = new XMLHttpRequest();
    const jsonFile = this.getFileToLoad(load);
    xhr.overrideMimeType('application/json');
    xhr.open('GET', jsonFile, true);
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          this.assignValue(load, xhr.responseText);
          resolve(true);
        } else {
          reject(`Impossibile caricare il file '${jsonFile}': ${xhr.status}`);
        }
      }
    };

    xhr.send(null);
  }

  public assignValue(load: LoadConfigType, value: string): void {
    switch (load) {
      case LoadConfigType.SETTINGS:
        this._settings = JSON.parse(value) as IAppConfig;
        break;
      case LoadConfigType.TEXT:
        this._text = JSON.parse(value) as TextConfig;
        break;
      case LoadConfigType.LOGIC:
        this._logic = JSON.parse(value) as LogicConfig;
        break;
    }
  }

  private getFileToLoad(load: LoadConfigType) {
    let jsonFile = '';

    switch (load) {
      case LoadConfigType.SETTINGS:
        jsonFile = `assets/config/config.${environment.name}.json`;
        break;
      case LoadConfigType.TEXT:
        jsonFile = `assets/institutes/${this.settings.instituteName}/text.json`;
        break;
      case LoadConfigType.LOGIC:
        jsonFile = `assets/institutes/${this.settings.instituteName}/config.json`;
        break;
    }

    return jsonFile;
  }
}

export enum LoadConfigType {
  SETTINGS,
  TEXT,
  LOGIC
}
